import { render } from "./ManagerReports.vue?vue&type=template&id=7ae6790e"
import script from "./ManagerReports.vue?vue&type=script&lang=js"
export * from "./ManagerReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__